module.exports = __webpack_public_path__ + "img/zk-icon-binding.c76844d4.svg";